import { Grid } from '@mui/joy'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { InspectionReasonCodeEnum } from '~/shared/config/enums'
import { TMS_DOMAIN } from '~/shared/config/env'
import { LinkDecorator } from '~/shared/ui/Buttons'
import { Switch, TextareaInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type MainProps = {
  carId?: UniqueId
  driverExtId?: UniqueId
  loading: boolean
}

export function Main({ carId, driverExtId, loading }: MainProps) {
  const { t } = useTranslation()
  const { watch } = useFormContext()

  const reasonCode = watch('reasonCode')
  const isAfterAccident = reasonCode === InspectionReasonCodeEnum.AFTER_ACCIDENT
  const isRefund = reasonCode === InspectionReasonCodeEnum.REFUND

  return (
    <Container>
      <ContainerTitle>{t('form.main information')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <TextInput
            label='form.plate number'
            name='plateNumber'
            readOnly
            skeletonShow={loading}
            endDecorator={
              carId && (
                <LinkDecorator
                  tooltipText={t('form.go to car card')}
                  href={`${TMS_DOMAIN}cars/${carId}`}
                />
              )
            }
          />
        </Grid>
        <Grid xs={4.4}>
          <TextInput
            label='form.driver'
            name='driverFullName'
            readOnly
            skeletonShow={loading}
            endDecorator={
              driverExtId && (
                <LinkDecorator
                  tooltipText={t('form.go to driver card')}
                  href={`${TMS_DOMAIN}drivers/${driverExtId}`}
                />
              )
            }
          />
        </Grid>
        <Grid xs={1.6}>
          <Switch
            labelI18n='form.participated'
            name='withDriverParticipation'
            readOnly
            skeletonShow={loading}
            formControlProps={{ sx: { marginTop: '40px' } }}
          />
        </Grid>

        <Grid xs={3}>
          <TextInput
            label='form.vin'
            name='vin'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={3}>
          <TextInput
            label='form.model'
            name='carBrandModel'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.mechanic'
            name='responsible'
            readOnly
            skeletonShow={loading}
          />
        </Grid>

        <Grid xs={4.4}>
          <TextInput
            label='form.inspection reason'
            name='reason'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={1.6}>
          <Switch
            labelI18n='form.by appointment'
            name='isPlanned'
            readOnly
            skeletonShow={loading}
            formControlProps={{ sx: { marginTop: '40px' } }}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.inspection duration'
            name='duration'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        {isRefund && (
          <Grid xs={12}>
            <TextInput
              label='form.refund reasons'
              name='refundReasons'
              readOnly
              skeletonShow={loading}
            />
          </Grid>
        )}

        <Grid xs={6}>
          <TextareaInput
            label='form.comment'
            name='comment'
            minRows={4}
            maxRows={4}
            readOnly
            skeletonShow={loading}
            sx={{
              height: '138px',
            }}
          />
        </Grid>
        <Grid xs={6}>
          {isAfterAccident && (
            <TextInput
              label='form.incident responsible'
              name='incidentResponsible'
              readOnly
              skeletonShow={loading}
            />
          )}
        </Grid>
      </Grid>
    </Container>
  )
}
